module.exports = __webpack_public_path__ + "static/media/afterburn.4509a206.png";